import { Address } from "@frontend/lyng/api/generated/graphql";

export const hasAddress = (
  address: Omit<Partial<Address>, "__typename"> | null,
) =>
  address &&
  (address.addressLine1 ||
    address.addressLine2 ||
    address.city ||
    address.zipCode);

export const parseAddress = (
  address: Omit<Partial<Address>, "__typename"> | null,
) => {
  if (!address || !hasAddress(address)) {
    return "";
  }

  const addressComponents = []; // This array will hold the parts of the address that are present.

  if (address.addressLine1 && address.addressLine1.trim() !== "") {
    addressComponents.push(String(address.addressLine1).trim());
  }

  if (address.addressLine2 && address.addressLine2.trim() !== "") {
    addressComponents.push(String(address.addressLine2).trim());
  }

  let zipCityPart = "";
  const zipCode = address.zipCode ? address.zipCode.trim() : "";
  const city = address.city ? address.city.trim() : "";

  if (zipCode !== "") {
    zipCityPart += zipCode;
  }
  if (city !== "") {
    if (zipCityPart !== "") {
      // If zipCode was already added, prefix city with a space.
      zipCityPart += " ";
    }
    zipCityPart += city;
  }

  if (zipCityPart !== "") {
    addressComponents.push(zipCityPart);
  }

  return addressComponents.join(", ");
};
